import React from "react";
import {Button, Dropdown} from "antd";
import type {MenuProps} from "antd";
import {PresentationListItemProps} from "../types";
import "./style.less"
import {useAuth} from "../../../../../context/authContext";
import {getImageLink} from "../../../../../helpers/mainHelpers";
import * as BUCKETS from "../../../../../enums/buckets"
import TextReader from "../../../../../components/text-reader/TextReader";
import {DeleteOutlined, EditOutlined, MoreOutlined} from "@ant-design/icons";

const PresentationListItem: React.FC<PresentationListItemProps> = ({index, presentationItem, presentationController}) => {
  const {canManageContent} = useAuth()

  const adminMenu: MenuProps["items"] = [
    {
      key: "edit",
      icon: <EditOutlined/>,
      label: "Редагувати",
      onClick: () => presentationController.editButtonHandler(presentationItem),
    },
    {
      key: "delete",
      danger: true,
      icon: <DeleteOutlined/>,
      label: "Видалити",
      onClick: () => presentationController.confirmDeletePresentationItem({presentationId: presentationItem.$id || ""}),
    },
  ]

  return <article className={`presentation-item ${index % 2 !== 0 ? "presentation-item--reversed" : ""}`}>
    <div className="presentation-item__media">
      {presentationItem.imageId
        ? <img
          className="presentation-item__image"
          src={getImageLink({imageId: presentationItem.imageId, bucketId: BUCKETS.MAIN})}
          alt="Близнюківська центральна районна лікарня"
          loading="lazy"
        />
        : <div className="presentation-item__placeholder" aria-hidden="true">БЦРЛ</div>}
    </div>

    <div className="presentation-item__content">
      <div className="presentation-item__number" aria-hidden="true">{String(index + 1).padStart(2, "0")}</div>
      <TextReader value={presentationItem.description}/>
    </div>

    {canManageContent && <Dropdown menu={{items: adminMenu}} trigger={["click"]}>
      <Button className="presentation-item__admin" type="text" shape="circle" icon={<MoreOutlined/>}
              aria-label="Керування інформаційним блоком"/>
    </Dropdown>}
  </article>
}

export default PresentationListItem
